import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ContactNumberInfoService, {
  type UpsertNumberInfoBody,
} from "@/services/contact/contact-number-info";

/**
 * Mutation composable for upserting contact number info (validity, route type, IVR, gatekeeper).
 * Invalidates contact-related queries on success.
 */
export function useUpsertContactNumberInfo() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (body: UpsertNumberInfoBody) => {
      const result = await ContactNumberInfoService.upsert(body);
      if (!result.data?.status) {
        throw new Error((result.data as { msg?: string })?.msg ?? "Failed to save number info");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
    },
  });

  return {
    upsertNumberInfo: mutation.mutateAsync,
    isUpserting: mutation.isPending,
    upsertError: mutation.error,
  };
}
